import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CoreModule } from '../core/core.module';
import { BtnComponent } from "../shared/components/button/btn.component";
import { SharedModule } from "../shared/shared.module";
import { AdmissionDateComponent, ExampleHeader } from './components/admission-date/admission-date/admission-date.component';
import { AgreementComponent } from "./components/agreement/agreement/agreement.component";
import { LoginComponent } from './components/authentication/login/login.component';
import { CardScanComponent } from "./components/card-scan/card-scan/card-scan.component";
import { CityComponent } from "./components/city/city/city.component";
import { ContractComponent } from "./components/contract/contract/contract.component";
import { ErrorPageComponent } from './components/error/error-page/error-page.component';
import { CheckPreHospiComponent } from './components/hospi/check-prehospi/check-prehospi.component';
import { SelectInsurerComponent } from "./components/insurer/select-insurer/select-insurer.component";
import { SelectLanguageComponent } from "./components/language/select-language/select-language.component";
import { LightComponent } from "./components/light/light/light.component";
import { SendMedicalFormComponent } from "./components/light/send-medical-form/send-medical-form.component";
import { MaintenancesComponent } from './components/maintenance/maintenances.component';
import { PatientDobComponent } from "./components/patient/patient-dob/patient-dob.component";
import { ProvinceComponent } from "./components/province/province/province.component";
import { ConfirmQuestionComponent } from "./components/question/confirm-question/confirm-question.component";
import { QuestionComponent } from "./components/question/question/question.component";
import { ScreenSaverComponent } from "./components/screensaver/screensaver/screen-saver.component";
import { ConfirmSiteComponent } from './components/site/confirm-site/confirm-site.component';
import { SiteComponent } from './components/site/site/site.component';
import { TitleComponent } from './components/title/title/title.component';
import { KioskEffects } from './state/kiosk.effects';
import { kioskFeatureKey, kioskReducer } from './state/kiosk.reducer';

@NgModule({
  declarations: [
    ErrorPageComponent,
    SelectLanguageComponent,
    CardScanComponent,
    SelectInsurerComponent,
    ContractComponent,
    PatientDobComponent,
    AgreementComponent,
    AdmissionDateComponent,
    ProvinceComponent,
    CityComponent,
    SiteComponent,
    ConfirmSiteComponent,
    CheckPreHospiComponent,
    QuestionComponent,
    ConfirmQuestionComponent,
    LightComponent,
    BtnComponent,
    TitleComponent,
    LoginComponent,
    ExampleHeader,
    MaintenancesComponent,
    ScreenSaverComponent,
    SendMedicalFormComponent
  ],
  imports: [CommonModule,SharedModule,CoreModule,
    StoreModule.forFeature(kioskFeatureKey, kioskReducer),
    EffectsModule.forFeature([KioskEffects]) ],
    exports:[SharedModule,CoreModule]
})
export class KioskModule {}
